import type { User } from './user';

export const emptyUser: User = {
  _id: '',
  customers: [],
  devices: [],
  email: '',
  groups: [],
  id: '',
  members: [],
  parentId: null,
  password: '',
  profile: {
    contactNumber: '',
    name: '',
  },
  role: 'customer',
  status: 'pending',
};
